import { useCallback, useEffect, useRef, useState } from "react";

export const OTP_COOLDOWN_SECONDS = 60;

export const LOGIN_LOCKED_PREFIX = "Too many failed login attempts";

export const OTP_STATUS = {
	1000: { ok: true, message: "Code verified.", action: "next" },
	1001: {
		ok: false,
		message: "This code has expired. Please request a new code.",
		action: "resend",
	},
	1002: {
		ok: false,
		message: "Invalid code. Please check the code and try again.",
		action: "stay",
	},
	1003: {
		ok: false,
		message: "We could not verify this code. Enter the most recent code you received, or try again later.",
		action: "stay",
	},
	1004: {
		ok: false,
		message: "Too many incorrect attempts. Please request a new code.",
		action: "restart",
	},
};

const UNKNOWN_OTP_STATUS = {
	ok: false,
	message: "Could not verify the code. Please try again.",
	action: "stay",
};

export const resolveOtpStatus = (code) => OTP_STATUS[code] || UNKNOWN_OTP_STATUS;

export async function postJson(url, body, extraHeaders = {}) {
	const res = await fetch(url, {
		method: "POST",
		headers: {
			Accept: "*/*",
			"Content-Type": "application/json",
			...extraHeaders,
		},
		body: JSON.stringify(body),
	});
	let data = {};
	try {
		data = (await res.json()) || {};
	} catch {
		data = {};
	}
	return { status: res.status, data };
}

export function useCountdown(seconds = OTP_COOLDOWN_SECONDS) {
	const [remaining, setRemaining] = useState(0);
	const timerRef = useRef(null);

	const stop = useCallback(() => {
		if (timerRef.current) {
			clearInterval(timerRef.current);
			timerRef.current = null;
		}
	}, []);

	const start = useCallback(() => {
		stop();
		setRemaining(seconds);
		timerRef.current = setInterval(() => {
			setRemaining((prev) => {
				if (prev <= 1) {
					stop();
					return 0;
				}
				return prev - 1;
			});
		}, 1000);
	}, [seconds, stop]);

	const reset = useCallback(() => {
		stop();
		setRemaining(0);
	}, [stop]);

	useEffect(() => stop, [stop]);

	return { remaining, start, reset };
}
